import { PaletteOptions } from '@mui/material';

const modernPalette: PaletteOptions = {
  primary: {
    900: '#1142A5',
    800: '#1E56B8',
    700: '#2C6ACB',
    600: '#3A7EDE',
    500: '#4891FF',
    400: '#67A5FF',
    300: '#86B9FF',
    200: '#B5D3FF',
    100: '#D9E9FF',
    50: '#EDF4FF',

    main: '#4891FF',
  },
  secondary: {
    25: '#2C0439',
    50: '#3F0552',
    100: '#550B6E',
    200: '#6B1A8B',
    300: '#812BA8',
    400: '#8D30C3',
    500: '#922ED5',
    600: '#9735E2',
    700: '#AF62E9',
    800: '#C994F1',
    900: '#E7CCFA',

    main: '#9735E2',
  },
  error: {
    25: '#FEF0F0',
    50: '#FEE2E2',
    100: '#FED4D4',
    200: '#FEC6C6',
    300: '#FDB2B2',
    400: '#FB8C8C',
    500: '#FA6565',
    600: '#F93F3F',
    700: '#8C1D18',
    800: '#601410',
    900: '#410E0B',
    main: '#FA6565',
  },
  neutral: {
    25: '#F8F9FA',
    50: '#F3F4F6',
    100: '#E5E7EB',
    200: '#D1D5DB',
    300: '#9CA3AF',
    400: '#515a6d',
    500: '#4B5563',
    600: '#374151',
    700: '#1F2937',
    800: '#111827',
    900: '#0D111C',
    A100: '#FFFFFF1A',
  },
  info: {
    100: '#BEF0FF',
    300: '#92E5FF',
    400: '#7DE0FF',
    500: '#67DBFF',
    600: '#51D6FF',
    700: '#3DA5C7',
    800: '#2B748D',
    main: '#7DE0FF',
  },
  background: {
    default: '#1C1C20',
    paper: '#272734',
  },
  text: {
    primary: '#E5E7EB',
    secondary: '#9CA3AF',
    disabled: '#4B5563',
  },
  promoPage: {
    heading: '#FFFFFF',
    description: '#86B9FF',
    duration: '#B5D3FF',
    cardBackground: '#272734',
    buttonBorder: '#1142A5',
    buttonBackground: '#4891FF',
    buttonBackgroundHover: '#3A7EDE',
    separator: '#4891FF66',
  },
  gradient: 'linear-gradient(91.32deg, #4891FF 0%, #9735E2 100%)',
  divider: '#333',
} as const;

export default modernPalette;
